import { render, staticRenderFns } from "./MyPostulationsList.vue?vue&type=template&id=3e09ed32&scoped=true"
import script from "./MyPostulationsList.vue?vue&type=script&lang=ts"
export * from "./MyPostulationsList.vue?vue&type=script&lang=ts"
import style0 from "./MyPostulationsList.vue?vue&type=style&index=0&id=3e09ed32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e09ed32",
  null
  
)

export default component.exports